var React = require('react');

function StarSelected (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5784 17.9616L5.93714 12.0877L6.00498 11.7944L5.77753 11.5972L1.22002 7.64598L7.24324 7.12313L7.5433 7.09708L7.66056 6.81965L10 1.28436L12.3394 6.81965L12.4567 7.09708L12.7568 7.12313L18.78 7.64598L14.2225 11.5972L13.995 11.7944L14.0629 12.0877L15.4216 17.9616L10.2583 14.8469L10 14.6911L9.74173 14.8469L4.5784 17.9616Z","fill":"#FFE502","stroke":"#A16207"}));
}

StarSelected.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = StarSelected;

StarSelected.default = StarSelected;
